/* Http Client */
import request from '@/utils/http/request'



//List
export async function fetchAll({ fullName, contactNumber, pageSize, pageNumber }) {
    return await request.get('/contactUs', {
        params: {
            fullName, contactNumber, pageSize, pageNumber
        }

    });
}